<template>
  <label>
    <input
      :id="getFieldID(schema)"
      type="checkbox"
      v-model="value"
      :autocomplete="schema.autocomplete"
      :disabled="disabled"
      :name="schema.inputName"
      :class="schema.fieldClasses"
    >
    {{schema.label}}
  </label>
</template>

<script>
import { abstractField } from 'vue-form-generator';

export default {
  mixins: [abstractField],
};
</script>

<style lang="postcss">
  .field-twiageCheckbox > label {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/customFields/checkbox/fieldTwiageCheckbox.vue